import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MilestoneProgressBar from 'src/components/MilestoneProgressBar';
import { OVERALL_STATUS_OPTIONS } from '../utils';
import s from './CapboxKeyMilestoneDates.styles';

const CapboxKeyMilestoneDates = ({job}) => {
    const { t } = useTranslation();
    const [milestoneDetails, setMilestoneDetails] = useState({});
    const [ overallCapStatusValue, setOverallCapStatus ] =  useState('');

    useEffect(() =>{
        const { capRequestAt, capServiceTargetEndAt, capEndAt, overallCapStatus } = job;
        setMilestoneDetails({
            startDate: capRequestAt,
            targetCompletionDate: capServiceTargetEndAt,
            completedDate: capEndAt
        });
        setOverallCapStatus(overallCapStatus);
    }, [job])

    return (
        <s.CapboxKeyMilestoneDatesWrapper>
           <s.CapboxKeyMilestoneDatesTitle>{t('CAP_STATUS_KEY_MILESTONE_DATES')}</s.CapboxKeyMilestoneDatesTitle>
           <s.CapboxKeyMilestoneDatesSubTitle>{t('CAP_STATUS')} : {OVERALL_STATUS_OPTIONS.find(item => item.value.toLowerCase() === overallCapStatusValue)?.label}</s.CapboxKeyMilestoneDatesSubTitle>
           <s.CapboxKeyMilestoneDatesLegend>
            <s.CapboxKeyMilestoneDatesDesc>{t('CAP_KEY_MILESTONE_DATES')} : </s.CapboxKeyMilestoneDatesDesc>
            <s.CapboxKeyMilestoneDatesLegendDetails><s.CapboxKeyMilestoneDimondIcon />{t('CAP_OUR_PROGRESS')}</s.CapboxKeyMilestoneDatesLegendDetails>
           </s.CapboxKeyMilestoneDatesLegend>
           <MilestoneProgressBar milestoneDetails={milestoneDetails} />
        </s.CapboxKeyMilestoneDatesWrapper>
    )
};

export default React.memo(CapboxKeyMilestoneDates);
